import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { AddBankAccount } from '../../features/data/data.actions';
import { selectAddInfoError } from '../../features/data/data.selectors';
import * as DialogActions from 'app/dialog/features/dialog.actions';

@Component({
  selector: 'app-signup03',
  templateUrl: './signup03.component.html',
  styleUrls: ['./signup03.component.scss']
})
export class Signup03Component implements OnInit {

  public plaid: any = {
    env: window['isProduction'] ? 'production': 'sandbox',
    publicKey: '4f83c65b3165d55570c3f52e504129',
    clientName: 'PayBee Inc.',
    countryCodes: ['US'],
    selectAccount: true
  };

  public stripe: any = {
    publicKey:  window['isProduction'] ? 'pk_live_OfIRqzWzHicXyOGlN0SJGE8r': 'pk_test_FwN7fsBMIIYs7e6MPpPdKa3s',
  }

  public form: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private store: Store
  ) { }

  ngOnInit(): void {
  }

  onBankLogin() {
    window['orgSignUp'].addBankAccount();
  }

  onAccountRoutingNumber() {
    const action = DialogActions.openDialog({
      payload: {
        name: "AccountRoutingNumber",
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee'
        },
      }
    });
    this.store.dispatch(action);
  }

  onDebitCard() {
    window['orgSignUp'].showCardReader();
  }

  onPlaidSuccess(event) {
    const { token, metadata } = event;
    this.store.dispatch({
      type: AddBankAccount.type,
      payload: {
        plaid_token: token,
        plaid_account_id: metadata.account_id
      }
    });
  }
  onPlaidExit(event) {}
  onPlaidLoad(event) {}
  onPlaidEvent(event) {}
  onPlaidClick(event) {}

}
